module.exports = __webpack_public_path__ + "static/media/3.2c8a7c45.png";